import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import AngledAxisTick from '../AngledAxisTick';
import { CATEGORICAL } from '../../../helpers/chartPalette'
import ChartDataTable from '../../graphData/ChartDataTable';
import { hoursTable } from '../../../helpers/dataHelpers/chartDataTable';

const formatDayLabel = (dayKey) => {
  const [y, m, d] = dayKey.split("-").map(Number);
  const date = new Date(y, (m || 1) - 1, d || 1);

  return new Intl.DateTimeFormat("nl-NL", {
    day: "2-digit",
    month: "2-digit",
  }).format(date);
};

const CumulativeHoursLineChart = ({
  data = [],
  color = CATEGORICAL[0],
  height = 240,
}) => {
  return (
    <>
    <div style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <LineChart
          data={data}
          margin={{ top: 10, right: 20, left: 0, bottom: 10 }}
        >
          <XAxis dataKey="day" tickFormatter={formatDayLabel} tick={<AngledAxisTick formatter={formatDayLabel} />} height={60} axisLine={false} tickLine={false} />
          <YAxis axisLine={false} tickLine={false} />
          <Tooltip
            formatter={(value, name) => {
              if (name === "cumulativeHours")
                return [`${value} uur`, "Cumulatief"];
              if (name === "hours") return [`${value} uur`, "Die dag"];
              return [value, name];
            }}
            labelFormatter={(label) => `Datum: ${label}`}
          />
          <Line
            type="monotone"
            dataKey="cumulativeHours"
            stroke={color}
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
    {/* Onder het vak met de vaste hoogte, anders valt de tabel erbuiten. */}
    <ChartDataTable table={hoursTable(data)} />
    </>
  );
};

export default CumulativeHoursLineChart;
